<template>
  <div
    class="video_btn market_video"
    @click="videoType = true"
    :class="[deviceType(), isNa ? 'na' : '']"
  ></div>
  <div
    class="video_content"
    v-if="videoType"
    :class="deviceType()"
  >
    <div class="vc">
      <iframe
        v-for="(item, index) in filteredVideos"
        :key="index"
        id="youtube"
        width="100%"
        height="100%"
        :src="item.content"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <div
        class="v_close"
        @click="videoType = false"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed } from "vue";
import { useI18n } from "vue-i18n";
import { deviceType } from "@/util/base";

const videoType = ref(false);
const { locale } = useI18n();
const XhLang = locale.value;

import { projectType } from "@/util/global";
const isNa = computed(() => projectType().area.indexOf("na") !== -1);

const props = defineProps(["VideoData"]);

// 过滤视频数据以仅显示特定语言的视频
const filteredVideos = computed(() => {
  return props.VideoData.flatMap(Object.values).filter(
    (item) => item.label === `videoUrl-${XhLang}`
  );
});
</script>

<style lang="scss" scoped>
.video_btn {
  width: 0.73rem;
  height: 0.73rem;
  background: url("../pages/zth/assets/images/video.png") no-repeat center;
  background-size: 100% auto;
  position: absolute;
  z-index: 2;
  top: 5rem;
  left: 50%;
  margin-left: -0.365rem;
  cursor: pointer;
  &.wap {
    top: 6rem;
  }
  &.pc {
    top: 4.7rem;
  }
}

.video_content {
  background: rgba($color: #000000, $alpha: 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  &.wap {
    .vc {
      width: 7rem;
      height: 4.2rem;
      .v_close {
        left: 50%;
        bottom: -0.8rem;
        top: auto;
        margin-left: -0.33rem;
      }
    }
  }

  .vc {
    width: 8.8rem;
    height: 5rem;
    border: 0.05rem solid #e0bb63;
    position: relative;
    background: #ffffff;

    .v_close {
      width: 0.66rem;
      height: 0.66rem;
      background: url("../pages/zth/assets/images/popup/close.png") no-repeat
        center;
      background-size: 100% auto;
      position: absolute;
      right: -0.8rem;
      top: -0.5rem;
      cursor: pointer;
    }
  }
}
</style>